import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  palette: {
    primary: {
      main: '#1E5A6B',
      light: '#4C8494',
      dark: '#123640',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#E0663D',
      light: '#F0967A',
      dark: '#B23F1E',
      contrastText: '#FFFFFF',
    },
    success: { main: '#2E8B57' },
    info: { main: '#2F6FED' },
    warning: { main: '#B8790A', contrastText: '#FFFFFF' },
    error: { main: '#C4432B' },
    background: {
      default: '#F3F6F5',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1B2A2E',
      secondary: '#5B6D70',
    },
  },
  typography: {
    fontFamily: ['Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(','),
  },
  shape: {
    borderRadius: 8,
  },
})

export default theme
